// Identity helpers keep authored content typed without runtime transformation.
export const defineDocument = (document) => document;
export const defineCollection = (collection) => collection;
//# sourceMappingURL=define.js.map